import APP from '@login/app';

import Login from '@login/Views/Login.vue';
import Register from '@login/Views/Register';
import Reset from '@login/Views/lost-password';
import RegisterCompleted from '@login/Views/RegisterCompleted.vue';
import { VIEW } from '@master/constants';

const default_meta = { app_name: 'Login', app_key: 'login', requires_auth: false, show_navbar: false, validate_adblock: false, show_sidebar: false, intercom: true };
export default [
  {
    path: '/login',
    component: APP,
    children: [
      {
        path: '/',
        name: VIEW.LOGIN,
        component: Login,
        meta: { ...default_meta },
      },
    ]
  },
  {
    path: '/register',
    name: VIEW.REGISTER,
    component: Register,
    alias: '/invite',
    meta: { ...default_meta, ...{ app_name: 'Register' }}
  },

  {
    path: '/register/completed',
    name: VIEW.REGISTER_COMPLETED,
    component: RegisterCompleted,
    meta: { ...default_meta, ...{ app_name: 'Register' }}
  },

  {
    path: '/reset',
    component: APP,
    children: [
      {
        path: '/',
        name: VIEW.RESET,
        component: Reset,
        meta: { ...default_meta },
      },
    ]
  },
];
